import type { UserType } from "../authorization/useAuthorization";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const loginSuccess = (data: {
  id: string;
  token: string;
  userType: UserType;
}) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const logout = () => ({
  type: LOGOUT,
});
